import { render, staticRenderFns } from "./ModalWithdrawSuccess.vue?vue&type=template&id=15c7a006"
import script from "./ModalWithdrawSuccess.vue?vue&type=script&lang=js"
export * from "./ModalWithdrawSuccess.vue?vue&type=script&lang=js"
import style0 from "./ModalWithdrawSuccess.vue?vue&type=style&index=0&id=15c7a006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports